export const RECOMMENDED_ACTIONS_DISMISSED = 'recommendedActionsDismissed';
export const RESTART_ONBOARDING = 'restartOnboarding';

export const RECOMMENDED_ACTIONS = {
  CREATE_NETWORK: 'Create Network',
  CREATE_ANALYZER: 'Create Analyzer',
};
